/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Drop_Ins_TodayInputs */

const en_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Today`)
};

const de_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommen heute`)
};

const es_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy`)
};

const fr_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui`)
};

const it_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In arrivo oggi`)
};

const pt_br2_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vindo hoje`)
};

const pl_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przychodzą dzisiaj`)
};

const hu_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma érkező`)
};

const ro_admin_dashboard_drop_ins_today = /** @type {(inputs: Admin_Dashboard_Drop_Ins_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vin Astazi`)
};

/**
* | output |
* | --- |
* | "Coming Today" |
*
* @param {Admin_Dashboard_Drop_Ins_TodayInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_drop_ins_today = /** @type {((inputs?: Admin_Dashboard_Drop_Ins_TodayInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Drop_Ins_TodayInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_drop_ins_today(inputs)
	if (locale === "de") return de_admin_dashboard_drop_ins_today(inputs)
	if (locale === "es") return es_admin_dashboard_drop_ins_today(inputs)
	if (locale === "fr") return fr_admin_dashboard_drop_ins_today(inputs)
	if (locale === "it") return it_admin_dashboard_drop_ins_today(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_drop_ins_today(inputs)
	if (locale === "pl") return pl_admin_dashboard_drop_ins_today(inputs)
	if (locale === "hu") return hu_admin_dashboard_drop_ins_today(inputs)
	return ro_admin_dashboard_drop_ins_today(inputs)
});
export { admin_dashboard_drop_ins_today as "admin.dashboard.drop_ins_today" }